import React, { Component } from 'react';

export default class TableArrayToCheckboxFormatter extends React.Component {
    constructor(props) {
        super(props);
        console.log('props in formatter', props );
        this.updateData = this.updateData.bind(this);
        this.state = { items: props.defaultValue };
        this.onToggleItem = this.onToggleItem.bind(this);
    }
    focus() {
    }
    onToggleItem(event) {
        console.log('toggle', event.currentTarget.name, this.state.items );
        const item = event.currentTarget.name;
        if (this.state.items.indexOf(item) < 0) {
            this.setState({ items: this.state.items.concat([ item ]) });
        } else {
            this.setState({ items: this.state.items.filter(r => r !== item) });
        }
    }
    updateData() {
        this.props.row[this.props.itemName] =  this.state.items;
        this.props.onUpdate({ 'row': this.props.row, 'cellName': this.props.itemName});
    }
    render() {
        const itemCheckBoxes = this.props.itemsList.map(item => (
            <div className="custom-cell-checkbox" key={ `span-${item}` }>
        <input
            type='checkbox'
            key={ item }
            name={ item }
            checked={ this.state.items.indexOf(item) > -1 }
            onKeyDown={ this.props.onKeyDown }
            onChange={ this.onToggleItem } />
        <label className="pleft10" key={ `label-${item}` } htmlFor={ item }>{ item }</label>
      </div>
        ));
        return (
            <span ref='inputRef'>
        { itemCheckBoxes }
                <button
                    className='btn btn-info btn-xs textarea-save-btn'
                    onClick={ this.updateData }>
          save
        </button>
      </span>
        );
    }
}
